import PageLayout from 'pages/Grading/PageLayout';
import PageProvider from 'pages/Grading/PageProvider';

const GradingPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default GradingPage;
